<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Avaliaçăo de Elegibilidade e admissăo - Inconsistências"
    >
        <template v-if="data">
            <rkm-area
                title="Identificacao do paciente"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="5">
                        <Item
                            label="Nome"
                            :value="data.paciente.campos.nomeCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.paciente.campos.cnsCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CPF"
                            :value="data.paciente.campos.cpfCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Data de nascimento"
                            :value="data.paciente.campos.dataNascimentoCidadao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="5">
                        <Item
                            label="Nome social"
                            :value="data.paciente.campos.nomeSocialCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Sexo"
                            :value="data.paciente.campos.sexoCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Raça/cor"
                            :value="data.paciente.campos.racaCorCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Etnia"
                            :value="data.paciente.campos.etnia"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Nome da mãe"
                            :value="data.paciente.campos.nomeMaeCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Desconhece mãe"
                            :value="data.paciente.campos.desconheceNomeMae"
                        />
                    </rkm-col>

                     <rkm-col cols="4">
                        <Item
                            label="Nome do pai"
                            :value="data.paciente.campos.nomePaiCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Desconhece pai"
                            :value="data.paciente.campos.desconheceNomePai"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="E-mail"
                            :value="data.paciente.campos.emailCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="PIS / PASEP | NIS"
                            :value="data.paciente.campos.numeroNisPisPasep"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="IBGE (Nascimento)"
                            :value="data.paciente.campos.codigoIbgeMunicipioNascimento"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Nacionalidade"
                            :value="data.paciente.campos.nacionalidadeCidadao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="País de nascimento"
                            :value="data.paciente.campos.paisNascimento"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Data de naturalização"
                            :value="data.paciente.campos.dtNaturalizacao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Portaria de naturalização"
                            :value="data.paciente.campos.portariaNaturalizacao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Data de entrada no Brasil"
                            :value="data.paciente.campos.dtEntradaBrasil"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.paciente.inconsistencias" />

                <rkm-area title="Endereço">
                    <rkm-row>
                        <rkm-col cols="2">
                            <Item
                                label="Tipo de logradouro"
                                :value="data.paciente.campos.endereco.campos.tipoLogradouroNumeroDne"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <Item
                                label="Logradouro"
                                :value="data.paciente.campos.endereco.campos.nomeLogradouro"
                            />
                        </rkm-col>

                        <rkm-col cols="1">
                            <Item
                                label="Número"
                                :value="data.paciente.campos.endereco.campos.numero"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <Item
                                label="Sem número"
                                :value="data.paciente.campos.endereco.campos.stSemNumero"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="Bairro"
                                :value="data.paciente.campos.endereco.campos.bairro"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                label="Complemento"
                                :value="data.paciente.campos.endereco.campos.complemento"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                label="Ponto de referência"
                                :value="data.paciente.campos.endereco.campos.pontoReferencia"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <Item
                                label="CEP"
                                :value="data.paciente.campos.endereco.campos.cep"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="IBGE"
                                :value="data.paciente.campos.endereco.campos.codigoIbgeMunicipio"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="UF"
                                :value="data.paciente.campos.endereco.campos.numeroDneUf"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="Telefone"
                                :value="data.paciente.campos.endereco.campos.telefoneContato"
                            />
                        </rkm-col>
                    </rkm-row>

                    <Inconsistencia :inconsistencias="data.paciente.campos.endereco.inconsistencias" />
                </rkm-area>
            </rkm-area>

            <rkm-area
                title="Profissional responsável"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissional.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.profissional.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.profissional.campos.cnes"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.profissional.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="INE"
                            :value="data.profissional.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.profissional.campos.cboCodigo2002"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Turno"
                            :value="data.profissional.campos.turno"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Data"
                            :value="data.profissional.campos.dataAtendimento"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <Item
                            label="Procedência"
                            :value="data.profissional.campos.atencaoDomiciliarProcedencia"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissional.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Condições avaliadas"
                type="fieldset"
            >
                <rkm-table
                    hide-filters
                    hide-pagination
                    :items="data.condicoesAvaliadas.lista.map(value => ({ value }))"
                    :fields="[{ key: 'value', label: 'Condição avaliada' }]"
                />

                <Inconsistencia :inconsistencias="data.condicoesAvaliadas.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="CID"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <Item
                            label="CID Primário"
                            :value="data.cid.campos.cid10Principal"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <Item
                            label="CID Secundário"
                            :value="data.cid.campos.cid10SecundarioUm"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <Item
                            label="CID Terciário"
                            :value="data.cid.campos.cid10SecundarioDois"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.cid.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Conclusão"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Conclusão"
                            :value="data.conclusao.campos.atencaoDomiciliarModalidade"
                        />
                    </rkm-col>

                    <rkm-col v-if="data.conclusao.campos.atencaoDomiciliarModalidade">
                        <Item
                            :label="false"
                            :value="data.conclusao.campos.elegivel
                                ? data.conclusao.campos.conclusaoDestinoElegivel
                                : data.conclusao.campos.conclusaoDestinoInelegivel"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.conclusao.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Cuidador"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Cuidador"
                            :value="data.cuidador.campos.cuidadorCidadao"
                        />
                    </rkm-col>

                    <template v-if="data.cuidador.campos.possuiCuidador">
                        <rkm-col>
                            <Item
                                label="CNS"
                                :value="data.cuidador.campos.cnsCuidador"
                            />
                        </rkm-col>

                        <rkm-col>
                            <Item
                                label="CPF"
                                :value="data.cuidador.campos.cpfCuidador"
                            />
                        </rkm-col>
                    </template>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.cuidador.inconsistencias" />
            </rkm-area>
        </template>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error]
}
</script>